import { BasicEntity } from "projects/erp-app/src/app/core/models/basic-entity";
import { ThirdContactInformation } from "../third-contact-informations/third-contact-information.model";

export class ThirdContactQualifier extends BasicEntity {
    public ContactInformations?: ThirdContactInformation;
   
    constructor(entity?: Partial<ThirdContactQualifier>) {
        super(entity);
        Object.assign(this, entity);
    }
}
